import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, sub, center = false }) => (
  <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
    {overline && (
      <span className="text-xs font-bold uppercase tracking-[0.25em] text-gold">
        {overline}
      </span>
    )}
    <h2 className="font-hero mt-4 text-3xl font-semibold tracking-normal text-white md:text-4xl lg:text-5xl">
      {title}
    </h2>
    {sub && <p className="mt-5 text-base leading-relaxed text-neutral-400">{sub}</p>}
  </div>
);
